import {
  TableView,
  TableHeader,
  TableBody,
  Column,
  Row,
  Cell,
} from '@adobe/react-spectrum';

export type HeaderColumn<T> = {
  id: string;
  key: keyof T;
  name: string;
  width?: number;
};

export type TableBodyColumn = {
  id: string;
  name: string;
  width?: number;
};

export interface HelpTableProps<T> {
  header: HeaderColumn<T>[];
  body: T[];
  id: string;
  margin?: number;
  width?: number;
}

export const HelpTable = <T,>(props: HelpTableProps<T>) => {
  const { header, body, id, margin = 10, width = 100 } = props;

  return (
    <div>
      <TableView
        width={`${width}%`}
        margin={margin}
        overflowMode="wrap"
        aria-label="confirmExecuteLog-list"
      >
        {/* テーブルヘッダー */}
        <TableHeader columns={header}>
          {(column) => (
            <Column key={column.id} defaultWidth={`${column.width!}%`}>
              {column.name}
            </Column>
          )}
        </TableHeader>
        {/* テーブルボディ */}
        <TableBody>
          {body.map((data, index) => (
            <Row key={`${id}-${index}`}>
              {header.map((value) => (
                <Cell key={`${id}-${data[value.key]}-${value.key.toString()}`}>
                  {data[value.key] as string}
                </Cell>
              ))}
            </Row>
          ))}
        </TableBody>
      </TableView>
    </div>
  );
};
